
import MlTraining from "./components/View/MlTraining/MlTraining";
import Anonymizer from "./components/View/Anonymizer/Anonymizer";
import Runs from "./components/View/Runs/Runs";
import Cockpit from "./components/View/Cockpit/Cockpit";
import Jobs from "./components/View/Jobs/Jobs";
import React, {useContext} from "react";
import {Route, Routes, Navigate, useNavigate} from 'react-router-dom';
import {useDispatch} from "react-redux";
import {Callback} from "./components/Auth/Callback";
import {Logout} from "./components/Auth/Logout";
import {LogoutCallback} from "./components/Auth/LogoutCallback";
import {PrivateRoute} from "./components/Auth/PrivateRoute";
import {SilentRenew} from "./components/Auth/SilentRenew";
import {AuthContext} from "./components/Auth/AuthProvider";


export const SCRoutes = (props) => {


    const userManager = useContext(AuthContext);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (

        <Routes>

            <Route path="/signin-oidc" element={<Callback/>}/>
            <Route path="/logout" element={<Logout/>}/>
            <Route path="/logout/callback" element={<LogoutCallback/>}/>
            <Route path="/silentrenew" element={<SilentRenew/>}/>


            <Route path="/jobs/:id/:cmd"
                   element={
                       <PrivateRoute>
                           <Jobs/>
                       </PrivateRoute>
                   }
            />
            <Route path="/mltraining"
                   element={
                       <PrivateRoute>
                           <MlTraining/>
                       </PrivateRoute>
                   }
            />
            <Route path="/anonymizer"
                   element={
                       <PrivateRoute>
                           <Anonymizer/>
                       </PrivateRoute>
                   }
            />
            <Route path="/runs"
                   element={
                       <PrivateRoute>
                           <Runs/>
                       </PrivateRoute>
                   }
            />
            <Route path="/cockpit"
                   element={
                       <PrivateRoute>
                           <Cockpit/>
                       </PrivateRoute>
                   }
            />
            <Route path="/" element={<Navigate to="/mltraining" replace/>}/>


        </Routes>

    );
}
